// Полифил String.prototype.replaceAll для старых браузеров
// (Safari < 13.4, старый Yandex Browser, WebView в старых Android-приложениях
// и т. п. — там у строки нет метода replaceAll и код падает с
// "TypeError: x.replaceAll is not a function").
//
// На сервере (Node 15+) метод уже есть — guard ниже делает полифил no-op.
// Импортируется первой строкой в pages/_app.tsx, поэтому отрабатывает
// до выполнения любого пользовательского кода на клиенте.

if (typeof String.prototype.replaceAll !== "function") {
  // eslint-disable-next-line no-extend-native, func-names
  String.prototype.replaceAll = function (search, replacement) {
    if (search instanceof RegExp) {
      if (!search.flags.includes("g")) {
        throw new TypeError(
          "String.prototype.replaceAll called with a non-global RegExp argument",
        );
      }
      return this.replace(search, replacement);
    }
    return this.split(search).join(replacement);
  };
}
